<template>
	<div ref="popupContainer">
		<vs-popup
			:active.sync="showValidationPopup"
			title="Êtes-vous sûr de vouloir supprimer cette commande ?"
			style="z-index: 53001"
		>
			<div class="vx-row">
				<div class="vx-col sm:w-1/2">
					<vs-button class="mt-2 w-full" @click="acceptDeleteOrder()"
						>Oui</vs-button
					>
				</div>
				<div class="vx-col sm:w-1/2">
					<vs-button class="mt-2 w-full" @click="declineDeleteOrder()"
						>Non</vs-button
					>
				</div>
			</div>
		</vs-popup>
		<!-- if more purchase  -->
		<vs-popup
			:active.sync="showIfNewOrderPopup"
			title="Souhaitez-vous ajouter un achat supplémentaire avant le changement de statut ?"
			style="z-index: 99999"
		>
			<div class="vx-row">
				<div class="vx-col sm:w-1/2">
					<vs-button
						color="primary"
						class="mt-2 w-full"
						@click="displayNewPurchasePopup(thisRow)"
						>Oui</vs-button
					>
				</div>
				<div class="vx-col sm:w-1/2">
					<vs-button
						color="primary"
						class="mt-2 w-full"
						@click="declineLivreNewPurchasePopup()"
						>Non</vs-button
					>
				</div>
			</div>
		</vs-popup>

		<vs-popup
			:active.sync="showNewPurchasePopup"
			title="Ajouter un achat dans cette commande"
			style="z-index: 53001"
		>
			<div ref="newPurchasePopupContainer"></div>
		</vs-popup>

		<vs-popup
			:active.sync="showNewOrderPopup"
			title="Création d'une commande"
			:button-close-hidden="true"
			style="z-index: 53001"
		>
			<div style="padding: 0 20px"></div>
		</vs-popup>

		<vs-popup
			:active.sync="showInfoPopup"
			title="Détail"
			style="z-index: 53001"
		>
			<div style="font-weight: 600">CONTENT</div>
			<div class="vx-row w-full" style="margin-left: 30px; padding-right: 30px">
				<div class="vx-row" style="white-space: nowrap">
					<div class="vx-col">
						Numero du mots : {{ thisOrderDetail.num_words || "-" }}
					</div>
					<div class="vx-col">
						Langue : {{ thisOrderDetail.language || "-" }}
					</div>
					<div class="vx-col">
						Complexité : {{ thisOrderDetail.difficulty || "-" }}
					</div>
				</div>
				<div
					class="vx-row w-full"
					v-if="purchasesList.length > 0"
					style="overflow: auto"
				>
					<PurchasesTable
						:purchases="purchasesList"
						:readOnly="true"
						class="w-full"
					/>
				</div>
				<div
					class="vx-row w-full"
					v-if="netlinksList.length > 0"
					style="overflow: auto"
				>
					<NetlinkTable
						:netlink="netlinksList"
						:netlinkTypes="netlinkTypes"
						:readOnly="true"
						class="w-full"
					/>
				</div>
			</div>
		</vs-popup>
		<vs-table
			class="mt-4"
			:key="refreshList"
			:data="ordersData"
			noDataText="Pas de commande"
		>
			<template
				slot="thead"
				style="
					 {
						z-index: -1 !important;
					}
				"
			>
				<vs-th
					v-if="fromProjectMang"
					class="white-txt pdl0"
					:style="{ backgroundColor: $props.fromGestion ? '#08B0B9' : '' }"
					>CLIENT</vs-th
				>
				<vs-th
					v-if="fromProjectMang"
					class="white-txt pdl0"
					:style="{ backgroundColor: $props.fromGestion ? '#08B0B9' : '' }"
					>N°CONTRAT</vs-th
				>
				<vs-th
					class="white-txt pdl0"
					:style="{ backgroundColor: $props.fromGestion ? '#08B0B9' : '' }"
					><div :class="{ 'text-white': $props.fromGestion }">
						{{ $props.nameCommande ? "COMMANDES" : "PRESTATIONS" }}
					</div></vs-th
				>
				<!-- <vs-th class="white-txt pdl0" :class="{'red-bg': $props.fromGestion}"></vs-th> -->
				<vs-th
					class="white-txt pdl0"
					:style="{
						width: '360px',
						backgroundColor: $props.fromGestion ? '#08B0B9' : '',
					}"
					><div style="text-align: center; width: 100%">
						<div :class="{ 'text-white': $props.fromGestion }">BRIEF</div>
					</div></vs-th
				>
				<vs-th
					class="white-txt"
					:style="{ backgroundColor: $props.fromGestion ? '#08B0B9' : '' }"
					><div class="w-full text-center">
						<div :class="{ 'text-white': $props.fromGestion }">CONSULTANT</div>
					</div></vs-th
				>
				<vs-th
					class="white-txt pdl0"
					:style="{ backgroundColor: $props.fromGestion ? '#08B0B9' : '' }"
					><div style="text-align: center; width: 100%">
						<div :class="{ 'text-white': $props.fromGestion }">STATUT</div>
					</div></vs-th
				>
				<vs-th
					class="white-txt pdl0"
					:style="{ backgroundColor: $props.fromGestion ? '#08B0B9' : '' }"
					><div style="text-align: center; width: 100%">
						<div :class="{ 'text-white': $props.fromGestion }">
							DATE DE LIVRAISON
						</div>
					</div></vs-th
				>

				<vs-th
					class="white-txt pdl0"
					:style="{ backgroundColor: $props.fromGestion ? '#08B0B9' : '' }"
					><div style="text-align: center; width: 100%">
						<div :class="{ 'text-white': $props.fromGestion }">DOC</div>
					</div></vs-th
				>
				<vs-th
					class="white-txt pdl0"
					:style="{ backgroundColor: $props.fromGestion ? '#08B0B9' : '' }"
					><div style="text-align: center; width: 100%">
						<div :class="{ 'text-white': $props.fromGestion }">FACTURABLE</div>
					</div></vs-th
				>
				<vs-th
					class="white-txt"
					:style="{ backgroundColor: $props.fromGestion ? '#08B0B9' : '' }"
					><div class="w-full text-right">
						<div :class="{ 'text-white': $props.fromGestion }">BUDGET</div>
					</div></vs-th
				>
				<vs-th
					class="white-txt"
					:style="{ backgroundColor: $props.fromGestion ? '#08B0B9' : '' }"
					><div class="w-full text-right">
						<div :class="{ 'text-white': $props.fromGestion }">PV HT</div>
					</div></vs-th
				>

				<vs-th
					class="pdl0"
					v-if="!readOnly"
					:style="{ backgroundColor: $props.fromGestion ? '#08B0B9' : '' }"
					><div :class="{ 'text-white': $props.fromGestion }">
						ACTION
					</div></vs-th
				>
			</template>

			<template slot-scope="{ data }">
				<vs-tr :key="index" v-for="(row, index) in data">
					<vs-td
						v-if="fromProjectMang"
						style="font-weight: 700; padding-left: 20px !important"
						>{{ row.name }}</vs-td
					>
					<vs-td
						v-if="fromProjectMang"
						style="font-weight: 700; padding-left: 20px !important"
					>
						<span
							@click.stop="event.stopPropagation()"
							@click="displayContractPopup(row.contract_id)"
							class="hvr-underline hvr-underline-out"
							>{{ row.contract_id }}</span
						>
					</vs-td>
					<vs-td
						v-if="!row.edit || readOnly"
						style="font-weight: 700; padding-left: 20px !important"
						>{{ getProductPrestation(row.product_id) }}</vs-td
					>
					<vs-td v-else>
						<vs-select
							v-model="row.product_id"
							class="w-full select-large"
							autocomplete
							id="select-control-width"
						>
							<vs-select-item
								:key="index"
								:value="item.id"
								:text="
									productOptions[0].category_name ==
									missionCategories[item.category - 1]
										? missionCategories[item.category - 1] +
										  ' - ' +
										  item.perform
										: 'Autre - ' + item.perform
								"
								v-for="(item, index) in productOptions.filter(
									(p) => p.deliverable == 1
								)"
								class="w-full"
							/>
						</vs-select>
					</vs-td>

					<vs-td
						v-if="!row.edit || readOnly"
						class="fw-bold commentary"
						style="overflow: hidden; width: 8px !important"
						>{{
							row.brief_text.toString().substr(0, 25) +
							(row.brief_text.toString().length > 25 ? "..." : "")
						}}</vs-td
					>
					<vs-td v-else
						><vs-input class="w-full" v-model="row.brief_text"
					/></vs-td>

					<vs-td v-if="!row.edit || readOnly" class="pdl0">
						<div
							style="display: flex; justify-content: center"
							v-if="row.account_manager_id"
						>
							<div class="vx-row center-content">
								<div
									class="flex center"
									v-if="
										allCollaborators.find((m) => m.id == row.account_manager_id)
									"
								>
									<avatar-message-chip
										:key="index"
										:user="{
											users_id: row.account_manager_id,
											name:
												allCollaborators
													.find((m) => m.id == row.account_manager_id)
													.firstname.replace(/^\S/, (s) => s.toUpperCase()) +
												' ' +
												allCollaborators
													.find((m) => m.id == row.account_manager_id)
													.lastname.toUpperCase(),
										}"
										:contract="{
											id: row.contract_id,
											society_id: row.society_id,
										}"
									/>
								</div>
							</div>
						</div>
					</vs-td>
					<vs-td v-else>
						<vs-select
							v-model="row.account_manager_id"
							class="w-full select-medium mr-2"
							autocomplete
						>
							<vs-select-item
								:key="index"
								:value="item.id"
								:text="item.firstname + ' ' + item.lastname"
								v-for="(item, index) in getAllConsultants()"
								class="w-full"
							/>
						</vs-select>
					</vs-td>
					<vs-td class="text-center" v-if="$props.fromGestion">
						<!-- v-if="item.account_manager_ids.includes(String(activeUser.id)) || activeUser.type != '7'" -->
						<Slider
							v-if="
								row.account_manager_id
									.toString()
									.includes(String(activeUser.id)) || activeUser.type != '7'
							"
							:id1="row.id + 'offcard'"
							:id2="row.id + 'nullcard'"
							:id4="row.id + 'oncard'"
							:value="getStatusValue(row.status)"
							styleSld="font-size: 10px; background-color: rgba(224, 224, 224, 0.78);width: 165px;"
							styleOp1="color: black; background-color: #FF0000; width:55px; padding: 5px 10px;"
							styleOp2="color: black; background-color: #FFA800; width:55px; padding: 5px 10px;"
							styleOp3="color: black; background-color: #28C76F; width:55px; padding: 5px 10px;"
							styleDefault="color: black;"
							option1="Annulé"
							option2="À faire"
							option3="Fait"
							@btn-selected="updateTask(row, $event)"
						/>

						<vs-chip
							v-else
							style="width: 80px; margin-top: 2px"
							:color="getTaskStatusColor(row.status - 1)"
						>
							{{ getTaskStatus(row.status - 1) }}
						</vs-chip>
					</vs-td>

					<vs-td v-else class="pdl0">
						<div
							v-if="!row.edit || readOnly"
							class="flex center"
							style="padding-top: 3px"
						>
							<vs-chip
								style="
									width: 80px;
									margin-left: 10px;
									border-radius: 6px;
									padding-top: 2px;
								"
								:color="getOrderStatusColor(row.status)"
								>{{ getOrderStatus(row.status) }}</vs-chip
							>
						</div>
						<vs-td v-else style="width: 70px">
							<vs-select autocomplete v-model="row.status" class="w-full">
								<vs-select-item
									:key="index"
									:value="item.value"
									:text="item.text"
									v-for="(item, index) in statusOptions"
									class="w-full"
								/>
							</vs-select>
						</vs-td>
					</vs-td>
					<vs-td v-if="!row.edit || readOnly" class="pdl0">
						<div class="flex center" style="padding-top: 3px">
							{{ row.period }}
						</div>
					</vs-td>
					<vs-td v-else>
						<vx-input-group class="w-full bottom">
							<flat-pickr
								class="w-full"
								v-model="row.period"
								:config="configPeriodPicker"
								@keydown.native.delete.capture.stop.prevent
							/>
						</vx-input-group>
					</vs-td>
					<!-- menu for status -->

					<vs-td>
						<vx-tooltip
							:text="!row.link ? `Ajouter un lien` : `Voir`"
							position="top"
						>
							<vs-button
								v-if="!row.link"
								size="large"
								color="primary"
								type="flat"
								icon-pack="feather"
								style="
									 {
										z-index: 0;
									}
								"
								icon="icon-file-plus"
								@click="displayShowLinkPopup(row)"
							></vs-button>
							<vs-button
								v-else
								size="large"
								color="primary"
								type="flat"
								style="
									 {
										z-index: 0;
									}
								"
								icon-pack="feather"
								icon="icon-file"
								@click="displayShowLinkPopup(row)"
							></vs-button>
						</vx-tooltip>
					</vs-td>

					<vs-td v-if="!row.edit || readOnly" class="text-center pdl0">{{
						row.billable == 1 ? "Oui" : "Non"
					}}</vs-td>
					<vs-td v-else style="width: 50px">
						<vs-select
							autocomplete
							v-model="row.billable"
							class="w-full"
							@input="changeFacturable(row.billable)"
						>
							<vs-select-item
								:key="index"
								:value="item.value"
								:text="item.text"
								v-for="(item, index) in billableOptions"
								class="w-full"
							/>
						</vs-select>
					</vs-td>

					<vs-td
						v-if="!row.edit || readOnly"
						class="text-right"
						style="padding-right: 14px"
						>{{ convertInternationalNumberToFrenchCurrency(row.budget) }}</vs-td
					>
					<vs-td v-else style="width: 100px"
						><vs-input
							class="w-full"
							:id="index"
							v-model="row.budget"
							@keyup="
								row.budget = row.budget.replace(
									/^\D*(\d*(?:\.\d{0,2})?).*$/g,
									'$1'
								)
							"
					/></vs-td>
					<vs-td
						v-if="!row.edit || readOnly"
						class="text-right"
						style="padding-right: 14px"
						>{{
							row.billable
								? convertInternationalNumberToFrenchCurrency(row.billable_price)
								: ""
						}}</vs-td
					>
					<vs-td v-else style="width: 100px"
						><vs-input
							class="w-full inputx"
							v-model="row.billable_price"
							:disabled="!row.billable"
							@keyup="
								row.billable_price = row.billable_price.replace(
									/^\D*(\d*(?:\.\d{0,2})?).*$/g,
									'$1'
								)
							"
					/></vs-td>

					<vs-td v-if="!readOnly" style="width: 50px; overflow: visible">
						<el-dropdown id="order-dropdown">
							<vs-button
								class="btn-drop"
								icon-pack="feather"
								icon="icon-more-vertical"
								size="large"
							></vs-button>
							<el-dropdown-menu v-if="!row.edit" class="dropdown-menu">
								<el-dropdown-item name="1" @click="displayInfoPopup(row)"
									><vs-button
										icon-pack="feather"
										icon="icon-eye"
										class="dropdown-btn"
										>Détail</vs-button
									></el-dropdown-item
								>
								<el-dropdown-item
									name="2"
									@click="
										row.edit = true;
										tmpOrder = JSON.parse(JSON.stringify(row));
										refreshList++;
									"
									><vs-button
										icon-pack="feather"
										icon="icon-edit"
										class="dropdown-btn"
										style="margin-top: 5px"
										>Modifier</vs-button
									></el-dropdown-item
								>
								<el-dropdown-item name="3" @click="displayNewPurchasePopup(row)"
									><vs-button
										icon-pack="feather"
										icon="icon-plus-circle"
										class="dropdown-btn"
										style="margin-top: 5px"
										>Ajouter un achat</vs-button
									></el-dropdown-item
								>
								<el-dropdown-item
									name="4"
									@click="$emit('duplicate-order', row)"
									><vs-button
										icon-pack="feather"
										icon="icon-copy"
										class="dropdown-btn"
										style="margin-top: 5px"
										>Dupliquer</vs-button
									></el-dropdown-item
								>
								<el-dropdown-item name="5" @click="showDeletePopup(row)"
									><vs-button
										icon-pack="feather"
										icon="icon-trash-2"
										class="dropdown-btn"
										style="margin-top: 5px"
										>Supprimer</vs-button
									></el-dropdown-item
								>
							</el-dropdown-menu>
							<el-dropdown-menu v-else class="dropdown-menu editmode">
								<el-dropdown-item name="6" @click="showConfirmPopup(row)"
									><vs-button
										ref="save-order-button"
										icon-pack="feather"
										icon="icon-save"
										class="dropdown-btn"
										>Enregistrer</vs-button
									></el-dropdown-item
								>
								<el-dropdown-item
									name="7"
									@click="
										row.status = tmpOrder.status;
										row.period = tmpOrder.period;
										row.budget = tmpOrder.budget;
										row.billable = tmpOrder.billable;
										row.account_manager_id = tmpOrder.account_manager_id;
										row.brief_text = tmpOrder.brief_text;
										row.product_id = tmpOrder.product_id;
										row.billable_price = tmpOrder.billable_price;
										row.edit = false;
										refreshList++;
									"
									><vs-button
										icon-pack="feather"
										icon="icon-x"
										class="dropdown-btn"
										style="margin-top: 5px"
										>Annuler</vs-button
									></el-dropdown-item
								>
							</el-dropdown-menu>
						</el-dropdown>
					</vs-td>
				</vs-tr>
			</template>
		</vs-table>
	</div>
</template>

<script>
import Vue from "vue";
import VueCookies from "vue-cookies";
import dbFieldConvertor from "@/mixins/dbFieldConvertorMixin";
import ContractInfoPopup from "@/components/popups/ContractInfoPopup";
import utilsMixin from "@/mixins/utilsMixin";
import store from "@/store/store";
import PurchaseForm from "@/components/forms/purchase/Purchase";
import NetlinkTable from "@/components/tables/NetlinkTable";
import PurchasesTable from "@/components/tables/PurchasesTable";
import flatPickr from "vue-flatpickr-component";
import "flatpickr/dist/flatpickr.css";
import monthSelect from "flatpickr/dist/plugins/monthSelect";
import "flatpickr/dist/plugins/monthSelect/style.css";
import moment from "moment";
import ShareLinkPopup from "../popups/ShareLinkPopup.vue";
import Slider from "@/components/widgets/SliderWith3btn";
import AvatarMessageChip from "../chips/AvatarMessageChip.vue";
import Order from "../../entities/Order";

export default {
	name: "CommandeTable",
	components: {
		Slider,
		PurchaseForm,
		NetlinkTable,
		PurchasesTable,
		flatPickr,
		AvatarMessageChip,
	},
	props: {
		fromGestion: {
			type: Boolean,
			default: false,
		},
		nameCommande: {
			type: Boolean,
			default: false,
		},
		orders: Array,
		contract: {
			type: Object,
			default: null,
		},
		readOnly: {
			type: Boolean,
			default: false,
		},
		fromAllOrders: {
			type: Boolean,
			default: false,
		},
		fromProjectMang: {
			type: Boolean,
			default: false,
		},
	},
	mixins: [dbFieldConvertor, utilsMixin],
	data() {
		return {
			apiUrl: store.state.backendApiUrl,
			accountmanagerOptions: [],
			billableOptions: [
				{ text: "Non", value: 0 },
				{ text: "Oui", value: 1 },
			],
			missionCategories: [],
			netlinksList: [],
			thisOrderDetail: {},
			netlinkTypes: [],
			orderId: null,
			deliverydate: "",
			thisRow: {},
			ordersData: [],
			order_id: null,
			orderToDelete: null,
			productOptions: [],
			purchasesList: [],
			refreshList: 0,
			showInfoPopup: false,
			showValidationPopup: false,
			showIfNewOrderPopup: false,
			showNewOrderPopup: false,
			showNewPurchasePopup: false,
			showLinkPopup: false,
			statusOptions: [],
			tmpOrder: "",
			configPeriodPicker: {
				locale: require("flatpickr/dist/l10n/fr.js").default.fr,
				plugins: [
					new monthSelect({
						shorthand: true,
						dateFormat: "m/Y",
						altFormat: "m-Y",
						theme: "light",
					}),
				],
			},
		};
	},
	created() {
		this.fetchAllCollaborators();
		this.getAllProducts();
		this.getAllProductsCategories();
		this.getAllProductsSubCategories();
		// All orders including termier should be display or not

		if (this.$props.fromAllOrders || this.$props.fromGestion) {
			this.ordersData = this.$props.orders;
		} else {
			this.fetchOrderByContractId(this.$props.contract.id)
				.then((res) => {
					this.ordersData = res.filter((o) => [1, 2].includes(o.status));
				})
				.catch((err) => {
					console.error(err);
				});
		}
		let userInfo = VueCookies.isKey("userInfo")
			? VueCookies.get("userInfo")
			: null;
		this.statusOptions =
			userInfo.type != 9 && userInfo.hasAccess != 1
				? [
						{ text: "À faire", value: 1 },
						// {text: "En cours", value: 2},
						{ text: "Fait", value: 2 },
						{ text: "Annulé", value: 3 },
				  ]
				: [
						{ text: "À faire", value: 1 },
						// {text: "En cours", value: 2},
						{ text: "Fait", value: 2 },
						{ text: "Annulé", value: 3 },
						{ text: "Terminée", value: 4 },
				  ];
	},
	beforeDestroy() {
		// Run your function here
		this.cleanup();
	},
	mounted() {
		this.getAllAccountManager();
		this.getAllProductForCategory();
	},
	watch: {
		orders: {
			deep: true,
			handler: function (data) {
				this.ordersData = JSON.parse(JSON.stringify(data));
				if (!this.$props.fromAllOrders) {
					this.ordersData = this.ordersData.filter((o) => o.status != 4);
				}
				this.refreshList++;
			},
		},
	},
	computed: {
		allContractsWithContractsUsers: () => {
			return store.state.contracts_contracts_users;
		},
		isEditingBtn: () => {
			return store.getters.getIsEditCommadeBtn;
		},
		products: () => {
			return store.state.products;
		},
		activeUser() {
			return VueCookies.get("userInfo");
		},
		all_orders: () => {
			return store.state.allOrderList;
		},
		allProductsSubCategories: () => {
			return store.state.products_sub_categories;
		},
		allCollaboratorsAvatar: () => {
			return store.state.collaborators_avatar;
		},
		allCollaborators: () => {
			return store.state.collaborators;
		},
	},
	methods: {
		fetchAllCollaborators() {
			if (this.allCollaborators.length == 0) {
				store.dispatch("fetchAllCollaborators");
			}
			return this.allCollaborators;
		},
		getAllConsultants() {
			return this.allCollaborators.filter((collaborator) =>
				[3, 6, 7, 9].includes(collaborator.type)
			);
		},
		/**
		 * Fetch all orders for a contract
		 * @param cId - contract id
		 */
		fetchOrderByContractId(cId) {
			return new Promise((resolve, reject) => {
				Order.getByContractId(cId)
					.then((res) => {
						if (this.$props.fromAllOrders || this.$props.fromGestion)
							resolve(res);
						else resolve(res.filter((o) => o.status != 4)); // filtering finished orders
					})
					.catch((err) => {
						reject(err);
					});
			});
		},
		getAllOrdersForContract() {
			try {
				this.$http
					.get(
						this.apiUrl
							? this.apiUrl +
									"orders/get/contract/" +
									this.$props.contract.contract_id
							: store.state.backendApiUrl +
									"orders/get/contract/" +
									this.$props.contract.contract_id
					)
					.then((res) => {
						this.ordersData = res.data;
					})
					.catch((error) => {
						//console.log(error);
					});
			} catch (e) {
				console.error(e);
			}
		},
		getOrderContract(id) {
			//if(!id) return [];
			let thisOrders = this.all_orders.filter(
				(ele) => ele.contract_id == id && [1, 2].includes(ele.status)
			);
			// this.showOrderTable = thisOrders.length == 0? false: true;
			return thisOrders;
		},
		updateTask(order, orderstatus) {
			let obj = { ...order, status: orderstatus + 1 };
			this.updateOrder(obj);
		},
		getStatusValue(val) {
			let d = val - 1;
			return d;
		},
		cleanup() {
			this.ordersData.forEach((ele) => {
				ele.edit = false;
			});
		},
		changeFacturable(facturable) {
			if (!facturable) {
				this.ordersData[0].billable_price = null;
				//this.orders[id].billable_price = 0;
			}
		},
		changeBudget(budget, id) {
			this.ordersData[0].budget = document.getElementById(`${id}`).value;
		},
		displayShowLinkPopup(row) {
			this.showLinkPopup = true;
			let ComponentClass = Vue.extend(ShareLinkPopup);
			let shareLinkPopup = new ComponentClass({
				propsData: {
					title: this.getProductPrestation(row.product_id),
					apiUrl: this.apiUrl,
					contract_id: row.contract_id,
					society_id: row.society_id
						? row.society_id
						: this.contract.society_id,
					society_name: row.name,
					order_id: row.id,
					popupActive: this.showLinkPopup,
				},
			});
			shareLinkPopup.$mount();
			shareLinkPopup.$on("refresh-data", () => {
				this.$emit("refresh-data");
				this.$emit("refresh-orders");
				//this.refreshTask()
			});
			shareLinkPopup.$on("close-popup", () => {
				this.showLinkPopup = false;
			});
		},

		/**
		 * @function displayNewPurchasePopup show a popup to add a new purchase
		 */
		displayNewPurchasePopup(row) {
			this.showIfNewOrderPopup = false;
			this.showNewPurchasePopup = true;
			let ComponentClass = Vue.extend(PurchaseForm);
			let purchasePopup = new ComponentClass({
				propsData: {
					secondClose: false,
					//checking if its from gestion project view all commande
					societyId: this.$props.fromProjectMang
						? row.society_id
						: this.$props.contract.society_id,
					contractId: this.$props.fromProjectMang
						? row.contract_id
						: this.$props.contract.id,
					orderId: row.id,
					url: this.apiUrl,
					productsCategories: this.missionCategories,
				},
			});
			purchasePopup.$mount();
			purchasePopup.$on("close-popup", () => {
				this.showNewPurchasePopup = false;
				row.edit = false;
			});

			let nb = this.$refs.newPurchasePopupContainer.children;
			if (nb.length == 0)
				this.$refs.newPurchasePopupContainer.appendChild(purchasePopup.$el);
		},
		/**
		 * Query our API to fetch all account manager
		 */
		getAllAccountManager() {
			this.$http
				.get(this.apiUrl + "users/all/accountmanager")
				.then((res) => {
					// //console.log("getAllAccountManager");
					this.accountmanagerOptions = res.data.filter(
						(collaborator) => collaborator.status == 1
					);
					this.accountmanagerOptions.unshift({
						id: null,
						firstname: "",
						lastname: "",
					});
				})
				.catch((err) => {
					console.error(err);
				});
		},
		/**
		 * Query our API to fetch all product for a category
		 */
		getAllProductForCategory() {
			let deliveryId = this.contract.delivery;
			if (!deliveryId) {
				deliveryId = 1;
			}
			this.$http
				.get(this.apiUrl + "product/all/" + deliveryId.toString())
				.then((res) => {
					// //console.log(res);
					this.productOptions = res.data;

					let cat = res.data[0].category_name;

					if (deliveryId == 7) {
						this.productOptions = this.productOptions.filter(
							(p) => p.category_name == cat
						);
					}
				})
				.catch((err) => {
					console.error(err);
				});
		},
		showConfirmPopup(row) {
			this.thisRow = row;
			if (row.status == 2) {
				this.deliverydate = moment().format("YYYY-MM-DD HH:MM:ss");
				this.updateOrder(row);
				this.showIfNewOrderPopup = true;
			} else {
				this.updateOrder(row);
			}
		},
		/**
		 * @function updateOrder update an order
		 * @param {object} row all info of an order
		 */
		updateOrder(row) {
			// this.setLoading(true, "save-order-button");
			this.$http
				.post(this.apiUrl + "orders/update", {
					order: {
						id: row.id,
						contract_id: row.contract_id,
						product_id: row.product_id,
						brief_text: row.brief_text,
						billable: row.billable,
						billable_price: row.billable_price,
						budget: row.budget,
						period: row.period,
						account_manager_id: row.account_manager_id,
						status: row.status,
						user_id: row.user_id,
						delivery_date: this.deliverydate,
					},
					edit: {
						edited_by_id: this.activeUser.id,
					},
				})
				.then((res) => {
					if (res) {
						this.$vs.notify({
							title: "Succes",
							text: "La commande a bien été mise à jour.",
						});
						row.edit = false;
						//if annule it disappear from list
						// if(row.status == 3) this.ordersData.splice(this.ordersData.indexOf(row), 1);
						this.ordersData.forEach((ele) => {
							if (ele.id == row.id) {
								ele.id = row.id;
								ele.contract_id = row.contract_id;
								ele.product_id = row.product_id;
								ele.brief_text = row.brief_text;
								ele.billable = row.billable;
								ele.billable_price = row.billable_price;
								ele.budget = row.budget;
								ele.period = row.period;
								ele.account_manager_id = row.account_manager_id;
								ele.status = row.status;
								ele.user_id = row.user_id;
								ele.delivery_date = this.deliverydate;
							}
						});
						// if(row.status != 3){
						this.refreshList++;
						if (!this.$props.fromGestion && !this.$props.fromAllOrders)
							this.fetchOrderByContractId();
						if (!this.$props.fromGestion) this.$emit("refresh-orders");
					} else {
						this.$vs.notify({
							title: "Echec",
							text: "La commande n'a pas été mise à jour.",
						});
					}
				})
				.catch((err) => {
					console.error(err);
					this.$vs.notify({
						title: "Echec",
						text: "La commande n'a pas été mise à jour.",
					});
				});
		},
		displayInfoPopup(order) {
			this.orderId = order.id;
			this.netlinksList = [];
			this.purchasesList = [];
			this.thisOrderDetail = order;
			/*
			 * this.$http.get(this.apiUrl + "netlink/type/all").then(list => {
			 * 	this.netlinkTypes = list.data;
			 * 	this.$http.get(this.apiUrl + "orders/all/withpurchases/" + order.id).then(res => {
			 * 		this.netlinksList = res.data[1];
			 * 		this.purchasesList = res.data[0];
			 * 		if(this.netlinksList.length == 0 && this.purchasesList.length == 0){
			 * 			this.$vs.notify({
			 * 				title: "Echec",
			 * 				text: "Aucun achat/netlink trouvé."
			 * 			});
			 * 			return;
			 * 		}
			 * 		else this.showInfoPopup = true;
			 * 	});
			 * });
			 */
			this.showInfoPopup = true;
		},

		getCollaboratorAvatar(userId) {
			let foundAvatar = this.allCollaboratorsAvatar.find(
				(avatar) => avatar.id == userId
			);
			if (foundAvatar) return foundAvatar.avatar;
			else return null;
		},

		getAllProducts() {
			if (this.store) this.store.dispatch("getAllProducts");
			else store.dispatch("getAllProducts");
		},

		getAllProductsCategories() {
			this.$http
				.get(this.apiUrl + "product/category/all")
				.then((res) => {
					// //console.log("getAllProductsCategories", res.data);
					this.missionCategories = res.data.map((row) => row.name);
				})
				.catch((err) => {
					console.error(err);
				});
		},

		getAllProductsSubCategories() {
			store.dispatch("getAllProductsSubCategories");
		},

		getProductPrestation(productId) {
			let foundProduct = this.products.find(
				(product) => product.id == productId
			);
			return foundProduct.perform;
		},
		displayContractPopup(contract_id) {
			//console.log("CONTRACTT NUMBER", contract_id);
			this.selectedContract = null;
			let foundContract = this.allContractsWithContractsUsers.findIndex(
				(row) => row.id == contract_id
			);
			if (foundContract < 0) {
				this.$vs.notify({
					title: "Erreur",
					text: "Contrat introuvable, contactez l'équipe technique.",
				});
				return false;
			}
			let account_manager_avatars = [];
			if (this.allContractsWithContractsUsers[foundContract].account_managers) {
				let contract_account_managers_names =
					this.allContractsWithContractsUsers[foundContract]
						.account_managers !== null
						? this.allContractsWithContractsUsers[
								foundContract
						  ].account_managers.split(", ")
						: [];
				let contract_account_managers = contract_account_managers_names.splice(
					0,
					contract_account_managers_names.length / 2
				);
				for (let i = 0; i < contract_account_managers.length; i++) {
					account_manager_avatars.push({
						name: contract_account_managers_names[i],
						users_id: contract_account_managers[i],
						is_lead:
							this.allContractsWithContractsUsers[foundContract].lead_am ==
							contract_account_managers[i]
								? 1
								: 0,
					});
				}
			}
			this.selectedContract =
				this.allContractsWithContractsUsers[foundContract];
			this.selectedContract.account_manager_avatars = account_manager_avatars;
			this.showContractPopup = true;

			//Instancie la class SocietyInfoPopup pour mount sur la balise div principale
			let ComponentClass = Vue.extend(ContractInfoPopup);
			let contractPopup = new ComponentClass({
				propsData: {
					contract: this.selectedContract,
					popupActive: this.showContractPopup,
					router: this.$router,
				},
			});
			// @modify-contract="modifyContract($event)"
			contractPopup.$mount();
			contractPopup.$on("modify-contract", (contractId) => {
				this.popupActive = false;
				this.modifyContract(contractId);
			});
			contractPopup.$on("modify-missions", (contractId) => {
				this.popupActive = false;
				this.modifyMissions(contractId);
			});

			this.$refs.popupContainer.appendChild(contractPopup.$el);
		},

		deleteOrder(order) {
			this.$http
				.delete(this.apiUrl + "orders/delete/" + order.id)
				.then((res) => {
					if (res) {
						this.$vs.notify({
							title: "Succes",
							text: "La commande a bien été supprimée.",
						});
						this.ordersData = this.ordersData.filter((o) => o != order);
						this.$emit("refresh-orders");
						this.refreshList++;
					} else {
						this.$vs.notify({
							title: "Echec",
							text: "La commande n'a pas été supprimée.",
						});
					}
				})
				.catch((err) => {
					console.error(err);
				});
		},

		showDeletePopup(order) {
			this.orderToDelete = order;
			this.showValidationPopup = true;
		},

		acceptDeleteOrder() {
			this.deleteOrder(this.orderToDelete);
			this.showValidationPopup = false;
		},

		declineDeleteOrder() {
			this.orderToDelete = null;
			this.showValidationPopup = false;
		},

		acceptNewOrder() {
			this.showNewPurchasePopup = false;
			this.$emit("show-order");
		},
		declineLivreNewPurchasePopup() {
			this.updateOrder(this.thisRow);
			this.showIfNewOrderPopup = false;
		},
	},
};
</script>

<style scoped>
>>> .vs-con-table .vs-con-tbody .vs-table--tbody-table .vs-table--thead {
	z-index: -1 !important;
}
.commentary {
	word-break: break-word;
}

.pdl0 {
	padding-left: 0 !important;
}

thead + tr {
	border: none !important;
}

thead > tr {
	background-color: #f3f2f7;
}

th > div {
	color: #6e6b7b;
	font-weight: normal;
	font-size: 11px;
	white-space: nowrap;
	margin: 10px;
}

.tr-values.vs-table--tr.tr-table-state-null {
	border-top: 1px solid rgb(235, 234, 238);
}
td {
	padding-left: 10px !important;
	color: black;
	font-size: 11px;
	font-weight: 500;
}
.vs-con-tbody.vs-table--tbody {
	border: none;
}

.btn-drop {
	display: inline;
	color: black;
	background-color: transparent !important;
	pointer-events: none;
	z-index: 999999;
}

.dropdown-btn {
	padding: 0 !important;
	position: relative;
	background: transparent !important;
}

.dropdown-btn:hover {
	color: #08b0b9;
}

#order-dropdown {
	width: 65px;
	height: 40px;
	display: flex;
	overflow: visible;
	flex-wrap: nowrap;
	white-space: nowrap;
	margin-top: -5px;
}

el-dropdown:hover .dropdown-menu {
	display: flex !important;
}
el-dropdown-menu {
	position: relative;
	z-index: 10000;
}
#order-dropdown > el-dropdown-menu {
	position: relative;
	display: none;
	flex-direction: column;
	background: #6e6b7b;
	color: white;
	padding: 10px;
	border-radius: 5px;
	right: 160px;
	bottom: 65px;
	/* margin-top: 10px; */
	cursor: pointer;
	font-weight: 400;
	/* z-index: 999; */
	height: fit-content;
}
#order-dropdown > .editmode {
	position: relative;
	display: none;
	flex-direction: column;
	background: #6e6b7b;
	color: white;
	padding: 10px;
	border-radius: 5px;
	right: 125px !important;
	bottom: 15px;
	/* margin-top: 10px; */
	cursor: pointer;
	font-weight: 400;
	/* z-index: 999; */
	height: fit-content;
}
</style>
